<!-- Load Summary View -->
<div *ngIf="load && !showCart" class="load-view-container">
  <mat-card class="load-info-card">
    <h3 class="card-title">Load Info</h3>
    <p><strong>Name:</strong> {{ load.name }}</p>
    <p>
      <strong>Status:</strong>
      {{ load.deliveryBoyId ? 'Assigned' : 'Unassigned' }}
    </p>
    <p><strong>Created:</strong> {{ load.createdAt | date:'medium' }}</p>
    <p>
      <strong>Note:</strong>
      <input type="text" [(ngModel)]="load.note" placeholder="Add a note" style="width:100%" />
    </p>
  </mat-card>

  <mat-card class="load-orders-card">
    <h3 class="card-title">Orders in Load</h3>
    <app-sales-orders-table [(orders)]="enrichedOrders"
                            (openOrder)="viewOrderDetails($event)">
    </app-sales-orders-table>

    <div class="summary-row">
      <span class="net-label">Net Amount:</span>
      <span class="net-value">{{ netAmount | currency:'INR' }}</span>
    </div>
  </mat-card>

  <button mat-raised-button color="primary" class="full-width" (click)="updateLoad()">
    Update
  </button>

  <button mat-raised-button color="black-white-btn" class="full-width" (click)="showAllOrders()">
    Show All Orders
  </button>

  <button mat-raised-button color="warn" class="full-width" (click)="deleteLoad()">
    Delete
  </button>
</div>

<!-- Cart View -->
<div *ngIf="showCart">
  <app-cart [selectedCustomer]="selectedCustomerFromList"
            [selectedProducts]="selectedProducts"
            [disableOrder]="true"
            [disableEdit]="true"
            [disableDelete]="true"
            [disableDraft]="true">
  </app-cart>  
</div>

<button mat-raised-button color="accent" class="full-width close-button" (click)="onCloseDetails()">
  Close Details
</button>
